import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ICuenta } from '../models/cuenta/ICuenta.interface';
import { ICuentaDetallado } from '../models/cuenta/ICuentaDetallado.interface';
import { IHttpResponse } from '../../../models/IHttpResponse.interface';
import { Observable } from 'rxjs';
import { ModuleBaseService } from 'src/app/core/services/base/module-service-base.class';
import { MODULOS } from 'src/app/core/constants/modulo.constant';

@Injectable({
  providedIn: 'root'
})
export class CuentaService  extends ModuleBaseService {

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    const http = inject(HttpClient);
    const url = inject<string>('BASE_URL' as any);

    super(http, url, MODULOS.SISTEMA, 'cuentas');
  }

  public ObtenerDetallado(cuentaId: number): Observable<IHttpResponse<ICuentaDetallado>> {
    return this.http.get<IHttpResponse<ICuentaDetallado>>(
      `${this.baseApiUrl}/api/v1/${MODULOS.SISTEMA}/Cuentas/${cuentaId}/Detallado`);
  }

  public InitilizeEntity(): ICuenta {
    return {
      id: 0,
      nombre: "",
      activo: false
    };
  }
}
